var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemServiceInActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.25 11.1013L1.57109 6.21094C1.52454 6.30679 1.50032 6.4106 1.5 6.51565V15.4826C1.50033 15.6169 1.53971 15.7486 1.61403 15.8641C1.68835 15.9795 1.79488 16.0744 1.9225 16.1389L10.86 20.6561C10.9794 20.7171 11.1135 20.7494 11.25 20.7499V11.1013Z",
    fill: "#E9E9EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57129 6.20703L11.2502 11.0974L20.9291 6.20703",
    stroke: "#C0C0C6",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.1016V20.7473",
    stroke: "#C0C0C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5775 16.1407L11.64 20.6579C11.5204 20.7183 11.3863 20.75 11.25 20.75C11.1137 20.75 10.9796 20.7183 10.86 20.6579L1.9225 16.1407C1.79488 16.0763 1.68835 15.9813 1.61403 15.8659C1.53971 15.7505 1.50033 15.6187 1.5 15.4844V6.51559C1.50033 6.38129 1.53971 6.24954 1.61403 6.1341C1.68835 6.01865 1.79488 5.92375 1.9225 5.85928L10.86 1.34206C10.9796 1.28166 11.1137 1.25 11.25 1.25C11.3863 1.25 11.5204 1.28166 11.64 1.34206L20.5775 5.85928C20.7051 5.92375 20.8117 6.01865 20.886 6.1341C20.9603 6.24954 20.9997 6.38129 21 6.51559V15.4825C21 15.6172 20.9608 15.7493 20.8865 15.8651C20.8121 15.9809 20.7054 16.0761 20.5775 16.1407Z",
    stroke: "#C0C0C6",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53418 3.52734L16.1257 8.37366V13.249",
    stroke: "#C0C0C6",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemServiceInActive);
export default __webpack_public_path__ + "static/media/ItemServiceInActive.3e46798ec0ce2ba01c626078d0bde468.svg";
export { ForwardRef as ReactComponent };